enum AppSubSections {
  CREATE = "create",
  CREATE_RESTRICTED = "create-restricted",
  EDIT = "edit",
  VIEW = "view",
  DELETE = "delete",
  COPY = "copy",
  NEW = "new",
  ROLE_REQUEST = "role-request",
}

export default AppSubSections;
